import { commentTransform } from './comment-transformation';

export const blogDetailTransform = blog => ({
  title: blog['title'],
  content: blog['content'],
  author: blog['author'],
  estimation: blog['estimation'],
  comments: blog['comments'].map(commentTransform),
});
